import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ship-cp" }
const _hoisted_2 = { class: "ship-cp__hero" }
const _hoisted_3 = { class: "hero__left" }
const _hoisted_4 = { class: "hero__icon" }
const _hoisted_5 = { class: "hero__text" }
const _hoisted_6 = { class: "hero__title" }
const _hoisted_7 = { class: "hero__subtitle" }
const _hoisted_8 = { class: "hero__time" }
const _hoisted_9 = { class: "hero__actions" }
const _hoisted_10 = { class: "ship-cp__defaults" }
const _hoisted_11 = { class: "section-head" }
const _hoisted_12 = { class: "section-head__title" }
const _hoisted_13 = {
  key: 1,
  class: "defaults-table"
}
const _hoisted_14 = { class: "defaults-table__name" }
const _hoisted_15 = { class: "defaults-table__value" }
const _hoisted_16 = { class: "defaults-table__unit" }
const _hoisted_17 = { class: "defaults-table__foot" }
const _hoisted_18 = { class: "ship-cp__ship" }
const _hoisted_19 = { class: "section-head" }
const _hoisted_20 = { class: "section-head__title" }
const _hoisted_21 = {
  key: 0,
  class: "status-chip"
}
const _hoisted_22 = { class: "section-head__actions" }
const _hoisted_23 = {
  key: 0,
  class: "section-skeleton"
}
const _hoisted_24 = {
  key: 2,
  class: "ship-param-grid"
}
const _hoisted_25 = { class: "ship-param-card__body" }
const _hoisted_26 = { class: "ship-param-card__head" }
const _hoisted_27 = { class: "ship-param-card__title" }
const _hoisted_28 = { class: "ship-param-card__head-right" }
const _hoisted_29 = {
  key: 0,
  class: "ship-param-card__tag ship-param-card__tag--readonly",
  title: "船舶级只读：值来自系统默认或用户端建船时填写，仅可在「默认参数」页签修改默认值"
}
const _hoisted_30 = {
  key: 1,
  class: "ship-param-card__tag"
}
const _hoisted_31 = {
  key: 2,
  class: "ship-param-card__tag ship-param-card__tag--editing"
}
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = { class: "ship-param-card__compare" }
const _hoisted_34 = { class: "ship-compare-col" }
const _hoisted_35 = { class: "ship-compare-col__value" }
const _hoisted_36 = { class: "ship-compare-col__unit" }
const _hoisted_37 = { class: "ship-compare-arrow" }
const _hoisted_38 = { class: "ship-compare-col ship-compare-col--now" }
const _hoisted_39 = { class: "ship-compare-col__unit" }
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "ship-param-card__footer" }
const _hoisted_42 = { class: "ship-param-card__key" }
const _hoisted_43 = { class: "drawer-header" }
const _hoisted_44 = { class: "drawer-header__title" }
const _hoisted_45 = { class: "drawer-body" }
const _hoisted_46 = { class: "drawer-section" }
const _hoisted_47 = { class: "meta-row" }
const _hoisted_48 = { class: "meta-row__value" }
const _hoisted_49 = { class: "meta-row" }
const _hoisted_50 = { class: "meta-row__value" }
const _hoisted_51 = { class: "drawer-section" }
const _hoisted_52 = {
  key: 2,
  class: "drawer-error"
}
const _hoisted_53 = { class: "drawer-section drawer-nav" }
const _hoisted_54 = { class: "drawer-nav__pos" }
const _hoisted_55 = { class: "drawer-footer" }

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import type { Component } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";

// 兼容 ESLint 缓存可能引用的历史变量名（page single-ship 单船模式下不再使用）
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
import {
  Aim,
  ArrowLeft,
  ArrowRight,
  Clock,
  Close,
  Coin,
  Edit,
  InfoFilled,
  Lock,
  Refresh,
  RefreshLeft,
  Right,
  Setting,
  Ship,
  Sunny,
  Tools,
  User,
  WarningFilled,
} from "@element-plus/icons-vue";
import {
  getSysConfigListApi,
  updateSysConfigApi,
  getShipConfigListApi,
  updateShipConfigApi,
  resetShipConfigApi,
  resetShipConfigKeyApi,
  SysConfigItem,
  ShipConfigShip,
} from "@/api/sysConfigApi";
import { getCurrenciesApi, getEffectiveRatesApi } from "@/api/exchangeRateApi";

type CategoryKey = "carbon" | "price" | "other";

const CURRENCY_KEY = "calc.currency";
const SIM_KEY = "sim.number";
/** SIM 卡号最大长度（与后端 ShipCalcParamService.MAX_SIM_NUMBER_LENGTH 一致） */
const SIM_MAX_LENGTH = 32;

export default /*@__PURE__*/_defineComponent({
  __name: 'ShipCalcParamView',
  setup(__props) {

const selectedShipId = ref<string>("");
const CATEGORY_META: Record<CategoryKey, { label: string; icon: Component }> = {
  carbon: { label: "碳排放因子", icon: Sunny },
  price: { label: "能源单价", icon: Coin },
  other: { label: "其它", icon: Setting },
};

function categoryOf(item: SysConfigItem): {
  key: CategoryKey;
  label: string;
  icon: Component;
} {
  const key = item.configKey.toLowerCase();
  const unit = (item.unit ?? "").toLowerCase();
  if (key.includes("carbon") || unit.includes("co")) {
    return { key: "carbon", ...CATEGORY_META.carbon };
  }
  if (key.includes("price") || unit.includes("元")) {
    return { key: "price", ...CATEGORY_META.price };
  }
  return { key: "other", ...CATEGORY_META.other };
}

/**
 * 船舶级只读参数（与后端 ShipCalcParamService.READONLY_SHIP_KEYS 保持一致）：
 * 能效K值——值来自系统默认或用户端建船填写，
 * 管理端"船舶参数"页签仅可查看，默认值在"默认参数"页签维护。
 * （原「平均电价」calc.price.avg.electricity 已下线：与用电单价语义重复）
 */
const READONLY_SHIP_KEYS = new Set(["calc.factor.energy.k"]);
function isReadonlyKey(configKey: string): boolean {
  return READONLY_SHIP_KEYS.has(configKey);
}

/** 船舶本位货币参数 key（渲染为下拉选择，非数值） */
function isCurrencyKey(configKey: string): boolean {
  return configKey === CURRENCY_KEY;
}

/**
 * SIM 卡号参数 key（船舶级信息，非计算参数）：
 * 字符串、默认为空——"默认参数"区不展示（无默认值概念），
 * "该船参数"区渲染为文本输入（支持清空），用户端只读展示
 */
function isSimKey(configKey: string): boolean {
  return configKey === SIM_KEY;
}

/** 该船当前本位货币（船舶参数卡单位动态显示用） */
function shipCurrency(): string {
  return String(currentShip.value?.values?.[CURRENCY_KEY] ?? "CNY");
}

/** 单价类参数 key（恢复默认提示文案用） */
function isPriceKey(configKey: string): boolean {
  return (
    configKey === "calc.price.diesel" || configKey === "calc.price.electricity"
  );
}

/** 当前生效汇率（对 CNY），外币船"默认值"列换算显示用 */
const effectiveRates = ref<Record<string, number> | null>(null);
const loadEffectiveRates = async () => {
  const r = await getEffectiveRatesApi();
  if (r) effectiveRates.value = r.rates;
};

/** 汇率(from→to)：对 CNY 交叉；任一外币缺汇率返回 null（调用方提示手动核对） */
const fxOf = (from: string, to: string): number | null => {
  const r = effectiveRates.value;
  if (!r) return null;
  const f = from === "CNY" ? 1 : r[from];
  const t = to === "CNY" ? 1 : r[to];
  if (!f || !t) return null;
  return f / t;
};

/**
 * 船舶页签左列"默认值"（数值+单位成对返回）：
 * 单价类按该船货币显示换算默认——外币默认 = svc_config 人民币默认 × 汇率
 * （与后端 getPricesForCurrency 同口径），单位随数值币种走（如 EUR/L）；
 * 未录汇率的外币或非单价参数显示人民币原值（单位人民币/L）
 */
function shipDefaultDisplay(d: SysConfigItem): { text: string; unit: string } {
  const cur = shipCurrency();
  const fx = cur !== "CNY" ? effectiveRates.value?.[cur] : null;
  if (
    d.configKey === "calc.price.diesel" ||
    d.configKey === "calc.price.electricity"
  ) {
    const suffix = d.configKey === "calc.price.diesel" ? "/L" : "/kWh";
    const v = parseFloat(d.configValue);
    if (fx && Number.isFinite(v)) {
      return { text: (v / fx).toFixed(3), unit: `${cur}${suffix}` };
    }
    return { text: d.configValue, unit: `人民币${suffix}` };
  }
  // SIM 卡号无默认值概念（恒为空），左列显示占位符
  if (isSimKey(d.configKey)) {
    return { text: "—", unit: "—" };
  }
  return { text: d.configValue, unit: d.unit || "—" };
}

/** 船舶参数卡"该船当前值"的单位：单价类按该船货币动态拼接，其余用全局 unit */
function shipUnitOf(d: { configKey: string; unit?: string | null }): string {
  if (d.configKey === "calc.price.diesel") return `${shipCurrency()}/L`;
  if (d.configKey === "calc.price.electricity") return `${shipCurrency()}/kWh`;
  return d.unit || "—";
}

/** 可选币种（接口拉取：已录汇率快照的币种 + CNY 基准；未录任何汇率时仅 CNY） */
const CURRENCY_OPTIONS = ref<{ code: string; symbol: string; cname: string }[]>(
  [{ code: "CNY", symbol: "¥", cname: "人民币" }]
);
const loadCurrencyOptions = async () => {
  const list = await getCurrenciesApi();
  if (list) {
    CURRENCY_OPTIONS.value = [
      { code: "CNY", symbol: "¥", cname: "人民币" },
      ...list.filter((c) => c.hasRate),
    ];
  }
};

const route = useRoute();
const router = useRouter();

/* 路由参数（shipId 从 query 传入）。
 * 注：vue-router 默认复用同名路由的组件实例，watch 不会在参数首次变化时触发，
 * 故 shipId 必须从 route.query 直接初始化（不能依赖 watch 的 immediate 行为）。*/
const shipId = ref<string>(String(route.query.shipId ?? "").trim());
/** setup 是否已完成（避免 watch 在 reloadAll 还未定义时被触发 TDZ） */
const loaded = ref(false);
watch(
  () => route.query.shipId,
  (v) => {
    const id = String(v ?? "").trim();
    shipId.value = id;
    if (id && loaded.value) {
      reloadAll();
    }
  }
);

/* 默认参数（svc_config）：只读预览 + 抽屉编辑 */
const defaults = ref<SysConfigItem[]>([]);
const defaultsDrawerVisible = ref(false);
const defaultsSaving = ref(false);
const defaultsEditingItem = ref<SysConfigItem | null>(null);
const defaultsEditingOriginal = ref<SysConfigItem | null>(null);
const defaultEditValue = ref<number | string>(0);
const defaultsCurrentIndex = ref(0);

const defaultValidationError = computed(() => {
  // 货币参数：非空即可（选项本身受控）
  if (
    defaultsEditingItem.value &&
    isCurrencyKey(defaultsEditingItem.value.configKey)
  ) {
    return defaultEditValue.value ? "" : "请选择货币";
  }
  const v = defaultEditValue.value;
  if (typeof v !== "number" || Number.isNaN(v)) return "请输入正数";
  if (!Number.isFinite(v)) return "不能为无穷大";
  if (v <= 0) return "必须为正数";
  return "";
});

const loading = ref(false);

/**
 * 默认参数区可见列表：过滤 SIM 卡号（船舶级信息，无默认值概念，
 * 后端 /sysConfig/update 同样拒绝修改其默认值，仅"该船参数"区按船录入）
 */
const visibleDefaults = computed<SysConfigItem[]>(() =>
  defaults.value.filter((d) => !isSimKey(d.configKey))
);

const loadDefaults = async () => {
  const resp = await getSysConfigListApi();
  if (resp) defaults.value = resp;
};

const openDefaultsManage = () => {
  if (visibleDefaults.value.length === 0) return;
  openDefaultEditor(visibleDefaults.value[0], 0);
};

function openDefaultEditor(item: SysConfigItem, idx: number) {
  defaultsEditingItem.value = { ...item };
  defaultsEditingOriginal.value = { ...item };
  // 货币参数存字符串，数值参数 parseFloat
  defaultEditValue.value = isCurrencyKey(item.configKey)
    ? item.configValue
    : parseFloat(item.configValue) || 0;
  defaultsCurrentIndex.value = idx;
  defaultsDrawerVisible.value = true;
}

function prevDefault() {
  if (defaultsCurrentIndex.value <= 0) return;
  openDefaultEditor(
    visibleDefaults.value[defaultsCurrentIndex.value - 1],
    defaultsCurrentIndex.value - 1
  );
}

function nextDefault() {
  if (defaultsCurrentIndex.value >= visibleDefaults.value.length - 1) return;
  openDefaultEditor(
    visibleDefaults.value[defaultsCurrentIndex.value + 1],
    defaultsCurrentIndex.value + 1
  );
}

async function confirmDefaultEdit() {
  if (!defaultsEditingItem.value || defaultValidationError.value !== "") return;
  // 货币参数直接提交字符串，数值参数保持原精度语义（String(number)）
  const newValStr = String(defaultEditValue.value);
  if (newValStr === defaultsEditingOriginal.value?.configValue) {
    ElMessage.info("新值与当前值相同");
    return;
  }
  defaultsSaving.value = true;
  try {
    const resp = await updateSysConfigApi(
      defaultsEditingItem.value.configKey,
      newValStr
    );
    if (resp !== null) {
      ElMessage.success(
        `默认参数「${defaultsEditingItem.value.cname}」已修改，仅影响之后新建的船舶`
      );
      defaultsDrawerVisible.value = false;
      await loadDefaults();
      await loadShipConfig();
    }
  } finally {
    defaultsSaving.value = false;
  }
}

/* 该船参数（svc_ship_config）：编辑区 */
const shipDefaults = ref<SysConfigItem[]>([]);
const shipsLoading = ref(false);
const shipOptions = ref<ShipConfigShip[]>([]);
const shipEditValues = ref<Record<string, number | string>>({});
const savingShip = ref(false);
const resetting = ref(false);

const currentShip = computed<ShipConfigShip | null>(
  () => shipOptions.value.find((s) => s.shipId === shipId.value) ?? null
);
const currentShipName = computed(
  () => currentShip.value?.shipName ?? "参数配置"
);
const customizedCount = computed(
  () => currentShip.value?.customizedKeys?.length ?? 0
);
function isCustomized(id: string): boolean {
  return !!currentShip.value?.customizedKeys?.includes(id);
}
function isEdited(id: string): boolean {
  const cur = shipEditValues.value[id];
  const ship = currentShip.value;
  const origRaw = ship?.values?.[id];
  // 货币/SIM 卡号参数：字符串比较
  if (isCurrencyKey(id) || isSimKey(id)) {
    if (isSimKey(id)) {
      return String(cur ?? "").trim() !== String(origRaw ?? "").trim();
    }
    return typeof cur === "string" && cur !== origRaw;
  }
  const orig = parseFloat(origRaw ?? "NaN");
  if (typeof cur !== "number" || Number.isNaN(orig)) return false;
  return Math.abs(cur - orig) > 1e-9;
}
const shipDirty = computed(() =>
  shipDefaults.value.some((d) => isEdited(d.configKey))
);

/**
 * 改币自动换算单价：货币下拉变化时，柴油/电价编辑框按 当前值 × 汇率(旧币→新币)
 * 即时换算（保留自定义定价水平），管理员可再手动微调后保存。
 *
 * 回填保护：页面加载/刷新时 fillShipEditValues 回填库值（如用户端改币后的新值）
 * 同样会触发值变化——但此时单价已是后端换算好的正确值，绝不能再乘一次汇率
 * （否则出现"第一次刷新显示二次换算错值、第二次才正常"）。
 * 用 suppress 标志抑制：watch 默认在 nextTick 前批量触发，标志清除放 nextTick 后。
 */
let suppressCurrencyWatch = false;
watch(
  () => shipEditValues.value[CURRENCY_KEY] as string | undefined,
  (val, old) => {
    if (suppressCurrencyWatch || !val || !old || val === old) return;
    const fx = fxOf(old, val);
    if (fx == null) {
      ElMessage.warning(
        `${old} → ${val} 的汇率未录入，请手动核对柴油/电价单价的数值`
      );
      return;
    }
    const round3 = (v: number) => Number(v.toFixed(3));
    const d = shipEditValues.value["calc.price.diesel"];
    const e = shipEditValues.value["calc.price.electricity"];
    if (typeof d === "number")
      shipEditValues.value["calc.price.diesel"] = round3(d * fx);
    if (typeof e === "number")
      shipEditValues.value["calc.price.electricity"] = round3(e * fx);
    ElMessage.info(
      `单价已按汇率 ${old} → ${val} 等价换算（可再手动调整后保存）`
    );
  }
);

const loadShipConfig = async () => {
  shipsLoading.value = true;
  try {
    const resp = await getShipConfigListApi();
    if (resp) {
      shipDefaults.value = resp.defaults;
      shipOptions.value = resp.ships;
      if (!currentShip.value) {
        ElMessage.warning("该船暂无参数记录");
      }
      fillShipEditValues();
    }
  } finally {
    shipsLoading.value = false;
  }
};

function fillShipEditValues() {
  const ship = currentShip.value;
  const values: Record<string, number | string> = {};
  for (const d of shipDefaults.value) {
    const raw = ship?.values?.[d.configKey] ?? d.configValue;
    // 货币/SIM 卡号参数存字符串，数值参数 parseFloat（异常回 0）
    if (isCurrencyKey(d.configKey) || isSimKey(d.configKey)) {
      values[d.configKey] = isCurrencyKey(d.configKey)
        ? raw || "CNY"
        : raw || "";
      continue;
    }
    const num = parseFloat(raw);
    values[d.configKey] = Number.isFinite(num) ? num : 0;
  }
  // 回填保护：抑制"改币自动换算 watch"（回填的是库值，单价已是正确值，
  // 触发换算会造成二次乘汇率 → 第一次刷新显示错值）
  suppressCurrencyWatch = true;
  shipEditValues.value = values;
  nextTick(() => {
    suppressCurrencyWatch = false;
  });
}

async function saveShip() {
  if (!shipId.value || !currentShip.value) return;
  const currencyBefore = String(
    currentShip.value.values?.[CURRENCY_KEY] ?? "CNY"
  );
  const currencyAfter = String(
    shipEditValues.value[CURRENCY_KEY] ?? currencyBefore
  );
  for (const d of shipDefaults.value) {
    // 货币走下拉、SIM 卡号为可空字符串，均无需正数校验
    if (isCurrencyKey(d.configKey) || isSimKey(d.configKey)) continue;
    const v = shipEditValues.value[d.configKey];
    if (typeof v !== "number" || !(v > 0) || !Number.isFinite(v)) {
      ElMessage.warning(`「${d.cname}」必须为正数`);
      return;
    }
  }
  // SIM 卡号格式校验（可空；非空时仅字母/数字/连字符）
  const simItem = shipDefaults.value.find((d) => isSimKey(d.configKey));
  if (simItem) {
    const sim = String(shipEditValues.value[simItem.configKey] ?? "").trim();
    if (sim && !/^[0-9A-Za-z-]{1,32}$/.test(sim)) {
      ElMessage.warning("SIM卡号仅支持 1~32 位字母/数字/连字符");
      return;
    }
  }
  // 只读参数不提交（后端同样拦截，此处避免整批 400）
  const items = shipDefaults.value
    .filter((d) => !isReadonlyKey(d.configKey))
    .map((d) => ({
      configKey: d.configKey,
      configValue: isCurrencyKey(d.configKey)
        ? String(shipEditValues.value[d.configKey])
        : isSimKey(d.configKey)
        ? String(shipEditValues.value[d.configKey] ?? "").trim()
        : String(
            Number.isFinite(shipEditValues.value[d.configKey])
              ? Number(
                  (shipEditValues.value[d.configKey] as number).toFixed(
                    precisionOf(d)
                  )
                )
              : shipEditValues.value[d.configKey]
          ),
    }));
  savingShip.value = true;
  try {
    const resp = await updateShipConfigApi(shipId.value, items);
    if (resp !== null) {
      // 币种变更提醒：单价数值不会自动换算，需人工按新币种语义核对
      if (currencyAfter !== currencyBefore) {
        ElMessage.warning(
          `本位货币已由 ${currencyBefore} 改为 ${currencyAfter}，请立即核对该船「柴油单价 / 平均电价」的数值（按 ${currencyAfter} 计价重新填写）`
        );
      }
      ElMessage.success(
        `船舶「${currentShip.value.shipName}」参数已保存，用户端 60 秒内生效`
      );
      await loadShipConfig();
    }
  } finally {
    savingShip.value = false;
  }
}

async function resetShip() {
  if (!shipId.value || !currentShip.value) return;
  resetting.value = true;
  try {
    const resp = await resetShipConfigApi(shipId.value);
    if (resp !== null) {
      ElMessage.success(
        `船舶「${currentShip.value.shipName}」参数已恢复默认值`
      );
      await loadShipConfig();
    }
  } finally {
    resetting.value = false;
  }
}

/** 单参数恢复默认（卡片右上角按钮；货币恢复联动单价，单价按该船币种换算默认） */
const keyResetting = ref<string>("");
const resetSingleKey = async (d: SysConfigItem) => {
  if (!shipId.value || keyResetting.value) return;
  const currencyNote = isSimKey(d.configKey)
    ? "（SIM 卡号默认为空，恢复即清空已录入的卡号）"
    : isCurrencyKey(d.configKey)
    ? "；柴油/电价单价将同时按默认货币联动恢复"
    : isPriceKey(d.configKey)
    ? "；将按本船币种取换算默认值"
    : "";
  try {
    await ElMessageBox.confirm(
      `确定将「${d.cname}」恢复为默认值${currencyNote}？`,
      "恢复默认",
      {
        confirmButtonText: "恢复",
        cancelButtonText: "取消",
        type: "warning",
      }
    );
  } catch {
    return;
  }
  keyResetting.value = d.configKey;
  try {
    const resp = await resetShipConfigKeyApi(shipId.value, d.configKey);
    if (resp !== null) {
      ElMessage.success(`「${d.cname}」已恢复默认值`);
      await loadShipConfig();
    }
  } finally {
    keyResetting.value = "";
  }
};

/* 加载 / 工具 / 路由返回 */
const reloadAll = async () => {
  loading.value = true;
  try {
    await Promise.all([loadDefaults(), loadShipConfig()]);
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.push({ name: "shipList" });
};

const formattedNow = computed(() => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
});

function stepOf(item: SysConfigItem): number {
  if (item.configKey.includes("price")) return 0.001;
  if (item.configKey.includes("carbon")) return 0.01;
  return 0.1;
}
function precisionOf(item: SysConfigItem): number {
  // 单价（柴油/电价）统一 3 位小数（外币换算值需要更高精度）；碳因子 3 位
  if (item.configKey.includes("price")) return 3;
  if (item.configKey.includes("carbon")) return 3;
  return 2;
}

function relativeTime(t: string): string {
  if (!t) return "--";
  const d = new Date(t);
  if (Number.isNaN(d.getTime())) return t;
  const diff = Date.now() - d.getTime();
  if (diff < 0) return formatFullTime(t);
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec} 秒前`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} 分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时前`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day} 天前`;
  return formatFullTime(t);
}

function formatFullTime(t: string): string {
  if (!t) return "--";
  const d = new Date(t);
  if (Number.isNaN(d.getTime())) return t;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
}

onMounted(() => {
  loaded.value = true;
  // 币种下拉数据（已录汇率的币种 + CNY）+ 当前生效汇率（外币船默认值换算显示），并行加载
  loadCurrencyOptions().catch(() => void 0);
  loadEffectiveRates().catch(() => void 0);
  if (shipId.value) {
    reloadAll();
  }
});
onUnmounted(() => {
  /* noop */
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "hero__back",
          text: "",
          circle: "",
          size: "large",
          icon: _unref(ArrowLeft),
          onClick: goBack
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, { size: 22 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Tools))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, [
            _createTextVNode(_toDisplayString(currentShipName.value) + " ", 1),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hero__title-divider" }, "·", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hero__title-sub" }, "参数配置", -1))
          ]),
          _createElementVNode("p", _hoisted_7, [
            _cache[7] || (_cache[7] = _createTextVNode(" KPI 计算参数管理中心 · ", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(formattedNow.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_tooltip, {
          content: "从服务端重新拉拉",
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Refresh),
              round: "",
              loading: loading.value,
              onClick: reloadAll
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" 刷新 ", -1)
              ]))]),
              _: 1
            }, 8, ["icon", "loading"])
          ]),
          _: 1
        })
      ])
    ]),
    (!shipId.value)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          class: "ship-cp__empty",
          description: "请从船舶列表选择船舶"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              round: "",
              onClick: goBack
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" 返回船舶列表 ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_icon, { size: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Setting))
                  ]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "全局默认参数", -1)),
                _createVNode(_component_el_tag, {
                  size: "small",
                  type: "info",
                  effect: "plain",
                  class: "section-head__tag"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" 仅作参考 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                round: "",
                icon: _unref(Edit),
                disabled: visibleDefaults.value.length === 0,
                onClick: openDefaultsManage
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" 调整默认值 ", -1)
                ]))]),
                _: 1
              }, 8, ["icon", "disabled"])
            ]),
            (visibleDefaults.value.length === 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  description: "默认参数未初始化",
                  class: "section-empty"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "defaults-table__head" }, [
                    _createElementVNode("span", null, "参数名"),
                    _createElementVNode("span", null, "当前默认值"),
                    _createElementVNode("span", null, "单位")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDefaults.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.configKey,
                      class: _normalizeClass(["defaults-table__row", `is-${categoryOf(item).key}`])
                    }, [
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["defaults-table__chip", `is-${categoryOf(item).key}`])
                        }, [
                          _createVNode(_component_el_icon, { size: 11 }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(categoryOf(item).icon)))
                            ]),
                            _: 2
                          }, 1024)
                        ], 2),
                        _createTextVNode(" " + _toDisplayString(item.cname), 1)
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.configValue), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.unit || "—"), 1)
                    ], 2))
                  }), 128)),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_icon, { size: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(InfoFilled))
                      ]),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createTextVNode(" 默认值仅在新建船舶时复制为该船初始快照；修改不影响已建船舶（已有船在下方独立维护）。单价默认按人民币计价，其他币种的默认值按当前汇率自动换算 ", -1))
                  ])
                ]))
          ]),
          _createElementVNode("section", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_icon, { size: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Ship))
                  ]),
                  _: 1
                }),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "该船参数", -1)),
                (currentShip.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createTextVNode(" 上次修改 · " + _toDisplayString(currentShip.value.updatetime
                  ? relativeTime(currentShip.value.updatetime)
                  : "尚未修改") + " ", 1),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
                      _createTextVNode(" 已改 " + _toDisplayString(customizedCount.value) + " 项 ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_popconfirm, {
                  title: "确定将该船参数恢复为默认值？单价按本船币种取预设（外币无预设时保留当前值），货币与能效K保持不变，SIM卡号将被清空",
                  "confirm-button-text": "恢复",
                  "cancel-button-text": "取消",
                  onConfirm: resetShip
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      round: "",
                      plain: "",
                      icon: _unref(RefreshLeft),
                      loading: resetting.value
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" 恢复默认 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["icon", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  round: "",
                  loading: savingShip.value,
                  disabled: !shipDirty.value,
                  onClick: saveShip
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" 保存修改 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ]),
            (shipsLoading.value && shipDefaults.value.length === 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: "skeleton-card"
                    }, [
                      _createVNode(_component_el_skeleton, {
                        rows: 3,
                        animated: ""
                      })
                    ])
                  }), 64))
                ]))
              : (shipDefaults.value.length === 0)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    class: "section-empty",
                    description: "默认参数未初始化，请先在「调整默认值」中配置"
                  }))
                : (_openBlock(), _createElementBlock("section", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipDefaults.value, (d) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: d.configKey,
                        class: _normalizeClass(["ship-param-card", [
              `ship-param-card--${categoryOf(d).key}`,
              {
                'is-modified':
                  isCustomized(d.configKey) || isEdited(d.configKey),
              },
            ]])
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "ship-param-card__bar" }, null, -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("h3", _hoisted_27, _toDisplayString(d.cname), 1),
                            _createElementVNode("div", _hoisted_28, [
                              (isReadonlyKey(d.configKey))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                    _createVNode(_component_el_icon, { size: 11 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Lock))
                                      ]),
                                      _: 1
                                    }),
                                    _cache[19] || (_cache[19] = _createTextVNode(" 只读 ", -1))
                                  ]))
                                : (isCustomized(d.configKey))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                      _createVNode(_component_el_icon, { size: 11 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Edit))
                                        ]),
                                        _: 1
                                      }),
                                      _cache[20] || (_cache[20] = _createTextVNode(" 已定制 ", -1))
                                    ]))
                                  : (isEdited(d.configKey))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                        _createVNode(_component_el_icon, { size: 11 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Aim))
                                          ]),
                                          _: 1
                                        }),
                                        _cache[21] || (_cache[21] = _createTextVNode(" 待保存 ", -1))
                                      ]))
                                    : _createCommentVNode("", true),
                              (!isReadonlyKey(d.configKey))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    class: "ship-param-card__reset",
                                    disabled: keyResetting.value === d.configKey,
                                    onClick: ($event: any) => (resetSingleKey(d))
                                  }, _toDisplayString(keyResetting.value === d.configKey ? "恢复中…" : "恢复默认"), 9, _hoisted_32))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "ship-compare-col__label" }, "默认值", -1)),
                              _createElementVNode("div", _hoisted_35, _toDisplayString(shipDefaultDisplay(d).text), 1),
                              _createElementVNode("div", _hoisted_36, _toDisplayString(shipDefaultDisplay(d).unit), 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_el_icon, { size: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Right))
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "ship-compare-col__label" }, "该船当前值", -1)),
                              (isCurrencyKey(d.configKey))
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 0,
                                    modelValue: shipEditValues.value[d.configKey],
                                    "onUpdate:modelValue": ($event: any) => ((shipEditValues.value[d.configKey]) = $event),
                                    disabled: isReadonlyKey(d.configKey),
                                    size: "large",
                                    class: "ship-compare-input"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(CURRENCY_OPTIONS.value, (c) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: c.code,
                                          value: c.code,
                                          label: `${c.cname} ${c.code} ${c.symbol}`
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                : (isSimKey(d.configKey))
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      modelValue: shipEditValues.value[d.configKey],
                                      "onUpdate:modelValue": ($event: any) => ((shipEditValues.value[d.configKey]) = $event),
                                      disabled: isReadonlyKey(d.configKey),
                                      maxlength: SIM_MAX_LENGTH,
                                      size: "large",
                                      class: "ship-compare-input ship-compare-input--sim",
                                      placeholder: "未录入",
                                      clearable: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                  : (_openBlock(), _createBlock(_component_el_input_number, {
                                      key: 2,
                                      modelValue: shipEditValues.value[d.configKey],
                                      "onUpdate:modelValue": ($event: any) => ((shipEditValues.value[d.configKey]) = $event),
                                      min: 0.0001,
                                      step: stepOf(d),
                                      precision: precisionOf(d),
                                      controls: false,
                                      disabled: isReadonlyKey(d.configKey),
                                      size: "large",
                                      class: "ship-compare-input",
                                      placeholder: "正数"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "precision", "disabled"])),
                              _createElementVNode("div", _hoisted_39, _toDisplayString(shipUnitOf(d)), 1)
                            ])
                          ]),
                          _createElementVNode("p", {
                            class: "ship-param-card__desc",
                            title: d.description
                          }, _toDisplayString(d.description), 9, _hoisted_40),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("code", _hoisted_42, _toDisplayString(d.configKey), 1)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
          ])
        ], 64)),
    _createVNode(_component_el_drawer, {
      modelValue: defaultsDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((defaultsDrawerVisible).value = $event)),
      direction: "rtl",
      size: "540",
      "show-close": false,
      "with-header": false,
      class: "defaults-drawer"
    }, {
      default: _withCtx(() => [
        (defaultsEditingItem.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("header", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["drawer-header__chip", `is-${categoryOf(defaultsEditingItem.value).key}`])
                  }, [
                    _createVNode(_component_el_icon, { size: 13 }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(categoryOf(defaultsEditingItem.value).icon)))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(categoryOf(defaultsEditingItem.value).label), 1)
                  ], 2),
                  _createElementVNode("h2", null, _toDisplayString(defaultsEditingItem.value.cname), 1)
                ]),
                _createVNode(_component_el_button, {
                  text: "",
                  circle: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (defaultsDrawerVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: 18 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Close))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "meta-row__label" }, "参数键", -1)),
                    _createElementVNode("code", _hoisted_48, _toDisplayString(defaultsEditingItem.value.configKey), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "meta-row__label" }, "上次修改", -1)),
                    _createElementVNode("span", _hoisted_50, [
                      _createVNode(_component_el_icon, { size: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(User))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(defaultsEditingItem.value.updaterId || "系统") + " ", 1),
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "meta-row__sep" }, "·", -1)),
                      _createVNode(_component_el_icon, { size: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Clock))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(formatFullTime(defaultsEditingItem.value.updatetime)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "drawer-section__label" }, "设置新值", -1)),
                  (
                defaultsEditingItem.value &&
                isCurrencyKey(defaultsEditingItem.value.configKey)
              )
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: defaultEditValue.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((defaultEditValue).value = $event)),
                        size: "large",
                        class: "drawer-input"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(CURRENCY_OPTIONS.value, (c) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: c.code,
                              value: c.code,
                              label: `${c.cname} ${c.code} ${c.symbol}`
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 1,
                        modelValue: defaultEditValue.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((defaultEditValue).value = $event)),
                        min: 0.0001,
                        step: stepOf(defaultsEditingItem.value!),
                        precision: precisionOf(defaultsEditingItem.value!),
                        controls: true,
                        size: "large",
                        class: "drawer-input",
                        placeholder: "请输入正数"
                      }, null, 8, ["modelValue", "step", "precision"])),
                  (defaultValidationError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createVNode(_component_el_icon, { size: 14 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(WarningFilled))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(defaultValidationError.value), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_el_button, {
                    disabled: defaultsCurrentIndex.value <= 0,
                    onClick: prevDefault
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowLeft))
                        ]),
                        _: 1
                      }),
                      _cache[29] || (_cache[29] = _createTextVNode(" 上一个 ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("span", _hoisted_54, [
                    _createTextVNode(_toDisplayString(defaultsCurrentIndex.value + 1) + " ", 1),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "drawer-nav__divider" }, "/", -1)),
                    _createTextVNode(" " + _toDisplayString(visibleDefaults.value.length), 1)
                  ]),
                  _createVNode(_component_el_button, {
                    disabled: defaultsCurrentIndex.value >= visibleDefaults.value.length - 1,
                    onClick: nextDefault
                  }, {
                    default: _withCtx(() => [
                      _cache[31] || (_cache[31] = _createTextVNode(" 下一个 ", -1)),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowRight))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("footer", _hoisted_55, [
                _createVNode(_component_el_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (defaultsDrawerVisible.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("取消", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: defaultsSaving.value,
                  disabled: defaultValidationError.value !== '',
                  onClick: confirmDefaultEdit
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode(" 保存修改 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})